module.exports = __webpack_public_path__ + "img/rak_middle@2x.9cca54bf.png";